<div class="data-table-container">
  <ng-container *ngFor="let category of recordCategories">
    <div class="section" [id]="category.id" *ngIf="category.records.length">
      <div class="header"><h4>{{ category.label }}</h4></div>
      <div class="records">
        <app-record *ngFor="let record of category.records" [record]="record" (deletedChatEvent)="removeRecord(category.records, record)"></app-record>
      </div>
    </div>
  </ng-container>
</div>
